import onUserHasConsentedToCookies from "../../../onUserHasConsentedToCookies";

// Pseudo-jQuery for Hubspot callbacks
(function () {
    window.jQuery = window.jQuery || function (nodeOrSelector) {
        if (typeof (nodeOrSelector) == 'string') {
            /* using s here is not a bug, it's a trick */
            return document.querySelector(s);
        }
        return nodeOrSelector;
    };
})();

export default class HubspotForm {
    static init() {
        let forms = document.querySelectorAll('.hubspot-form');
        if (!forms.length) {
            return;
        }

        // load delayed if not in hero
        let isCriticalPath = document.querySelector('.hero-image .hubspot-form');
        if (isCriticalPath) {
			onUserHasConsentedToCookies('necessary', () => HubspotForm.loadScript(), true);
        } else {
            window.addEventListener('load', () => {
                setTimeout(() => {
					onUserHasConsentedToCookies('necessary', () => HubspotForm.loadScript(), true);
				}, 300);
            });
        }

        HubspotForm.initOnHubspotLibraryLoaded();
    }

    static initOnHubspotLibraryLoaded() {
        if (!window.hbspt || !hbspt.forms) {
            // Hubspot Forms library not yet loaded
            setTimeout(() => HubspotForm.initOnHubspotLibraryLoaded(), 200);
            return;
        }

        Array.from(document.querySelectorAll('.hubspot-form')).forEach((el, index) => {
            // hubspot requires a id for each target
            let id = el.getAttribute('id');
            if(!id) {
                id = 'hubspot-dynamic-id-' + index;
                el.setAttribute('id', id);
            }

            hbspt.forms.create({
                target: '#' + id,
				formInstanceId: id,
                portalId: el.dataset.portalId,
                formId: el.dataset.formId,
                css: '',
                errorClass: 'form-control form-control-sm',
                onFormSubmit: function ($form) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({event: 'hubspot_form_submitted', hubspot_portal_id: el.dataset.portalId});
                },
                onFormReady: function (form) {
                    HubspotForm.typeFileStyling(form);
                }
            });
        });
    }

    static loadScript() {
        let tag = document.createElement('script');
        let firstScriptTag = document.getElementsByTagName('script')[0];

        tag.src = '//js.hsforms.net/forms/v2.js';
        if (firstScriptTag) {
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        } else {
            document.head.append(tag);
        }
    }

    static typeFileStyling(form) {
        let inputs = form.querySelectorAll('input[type="file"]');

        if (!inputs.length) return;

        //wrap
        Array.prototype.forEach.call(inputs, function (input) {
            if (!input || !input.id) {
                input.id = 'hs-input-file-' + Math.random().toString(36).substr(2, 9);
            }
            let label = document.createElement('LABEL');
            let wrapper = document.createElement('DIV');
            let labelText = document.createElement('SPAN');
            let labelButton = document.createElement('SPAN');

            labelText.classList.add('hs-input-file-label-text');
            labelButton.classList.add('hs-input-file-label-btn');
            label.setAttribute('for', input.id);
            label.classList.add('hs-input-file-label');
            labelButton.innerHTML = 'Choose file';
            label.appendChild(labelButton);
            label.appendChild(labelText);
            wrapper.classList.add('hs-input-file-wrapper');

            input.parentNode.insertBefore(wrapper, input);
            wrapper.appendChild(input);
            wrapper.appendChild(label);
        });

        /*read and set file names*/
        Array.prototype.forEach.call(inputs, function (input) {
            input.addEventListener('change', function () {
                let file, files, j, len1, ref, label, labelText;
                files = [];
                ref = input.files;
                for (j = 0, len1 = ref.length; j < len1; j++) {
                    file = ref[j];
                    files.push(file.name);
                }

                label = input.parentNode.querySelector('label[for="' + input.id + '"]');
                labelText = label.querySelector('.hs-input-file-label-text');

                if (files.length) {
                    labelText.innerHTML = '';
                }
                label.setAttribute('title', files ? files.join(', ') : '');

                if (labelText.parentNode.lastChild.nodeValue) {
                    return labelText.parentNode.lastChild.nodeValue = files.join(', ');
                } else {
                    return labelText.appendChild(document.createTextNode(files.join(', ')));
                }
            });

        });
    }
}
